// extracted by mini-css-extract-plugin
export var mainTitleFont = "text-module--mainTitleFont--3D7r6";
export var mainSubtitleFont = "text-module--mainSubtitleFont--1HkY8";